import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { getUmbracoMediaUrl } from "utils/getUmbracoMediaUrl"
import { Team } from "./TeamTabs"

const StyledContent = styled.div`
  display: flex;
  align-self: flex-end;
  flex-direction: column;
  gap: 12px;
  z-index: 2;
`

const StyledFaceCard = styled.div`
  display: flex;
  padding: 16px;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      180deg,
      rgba(5, 23, 17, 0) 0%,
      rgba(5, 23, 17, 0.8) 100%
    );
    z-index: 1;
    pointer-events: none;
  }
`

export default function FaceCard({ el }: { el: Team }) {
  return (
    <StyledFaceCard>
      <Image
        src={getUmbracoMediaUrl(el.teamMainImage)}
        alt={el.teamName}
        fill
        style={{ objectFit: "cover" }}
      />
      <StyledContent>
        <Typography variant="h3" color="white">
          {el.teamName}
        </Typography>
        <Typography variant="body2" color="white">
          {el.teamRole}
        </Typography>
      </StyledContent>
    </StyledFaceCard>
  )
}
